export default "47"
